"use client";
import Link from "next/link";
import { AlertCircle, ArrowLeft } from "lucide-react";
import { useTranslations } from 'next-intl';

export default function ProjectError() {
  const t = useTranslations('Projects');

  return (
    <div className={`min-h-[70vh] flex items-center justify-center px-6`}>
      <div className="max-w-md w-full text-center">
        <div className="mb-6 flex justify-center">
          <div className="p-4 bg-red-50 rounded-full">
            <AlertCircle className="w-12 h-12 text-red-500" />
          </div>
        </div>

        <h1 className={`text-3xl font-bold text-gray-200 mb-4`}>
          {t('oops_project_error')}
        </h1>

        <p className="text-gray-600 mb-8">
          {t('projects_error')}
        </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              href="/"
              className="flex items-center justify-center gap-2 px-6 py-3 bg-dark text-white rounded font-semibold hover:bg-gray-200 transition-all"
            >
              <ArrowLeft size={18} />
              {t('back')}
            </Link>
          </div>
      </div>
    </div>
  );
}